export const FNO_ONBOARDING_API_URLS = {
  FNO_FIP: '/v1/api/onboarding/fno/fip',
  ACTIVATE: '/v1/api/fno/activate',
  AA_CONSENT_INIT: '/v1/api/onboarding/fno/aa/consent/init',
  AA_DOWNLOAD_INIT: '/v2/api/onboarding/fno/aa/download/init',
  AA_DOWNLOAD_POLL: '/v1/api/onboarding/fno/aa/download/poll',
}

export const DERIVATIVE_API_URLS = {
  INITIATE: '/v1/api/derivative/initiate',
  UPDATE_REQUEST: '/v1/api/derivative/update-derivative-request',
  AA_CONSENT_INIT: '/v1/api/onboarding/derivative/aa/consent/init',
  AA_DOWNLOAD_INIT: '/v1/api/onboarding/derivative/aa/download/init',
}

export const BANK_MANDATE_API_URLS = {
  FETCH_BANK_LIST: '/v1/api/fetch/bank_list',
  FETCH_BANK_BRANCH: '/slr/v1/bank/search',
  REGISTER_BANK_PENNY_DROP_ADD: '/v1/api/bank_mandate/register/bank/penny-drop/add',
  BANK_VERIFICATION_STATUS_PENNY_DROP: '/v1/api/bank_mandate/bank/verification/status/pennyDrop',
  BANK_MANDATE_V2: '/v1/api/bank_mandate/v2/bank/client/all_bank',
  UPDATE_RAA: '/v1/api/wallet/v2/account/update/authorisation',
}

export const KYC_API_URLS = {
  GEO_LOCATION_VERIFY_IP_LOCATION: '/v1/api/kyc/v1/geo_location/verify-ip-location',
}

export const DOC_API_URLS = {
  USER_V1_GENERATE_HV_JWT: '/v1/api/doc/user/v1/generate_hv_jwt',
}

export const EKYC_API_URLS = {
  EKYC_SCREEN_CONFIGS: '/v1/api/user/v1/ekyc/screen-configs',
  EKYC_INIT: '/v1/api/user/v1/ekyc/init',
  EKYC_VALIDATE_OTP: '/v1/api/user/v1/ekyc/validate-otp',
}

export const COMMODITY_API_URLS = {
  ACTIVATE: '/v1/api/commodity/activate',
}

export const MAIN_ONB_API_URL = {
  PROGRESS_INIT: '/v1/api/onboarding/dcp/v1/progress/onboarding/init',
  PROGRESS_POLL: '/v1/api/onboarding/dcp/v1/progress/onboarding/poll',
  SUBMISSION_INIT: '/v1/api/onboarding/dcp/v1/submission/onboarding/init',
  SUBMISSION_POLL: '/v1/api/onboarding/dcp/v1/submission/onboarding/poll',
  SUBMISSION_SUBMIT: '/v1/api/onboarding/dcp/v1/submission/onboarding/submit',
};

export const DELTA_JOURNEY_API_URL = {
  PROGRESS_INIT: '/v1/api/onboarding/dcp/v1/progress/init',
  PROGRESS_POLL: '/v1/api/onboarding/dcp/v1/progress/poll',
  SUBMISSION_INIT: '/v1/api/onboarding/dcp/v1/submission/init',
  SUBMISSION_POLL: '/v1/api/onboarding/dcp/v1/submission/poll',
  SUBMISSION_SUBMIT: '/v1/api/onboarding/dcp/v1/submission/submit',
};

export const RESET_USER_ONBOARDING_JOURNEY_API_URL = '/v1/api/onboarding/dcp/v1/request/journey/reset'

export const DEFAULT_URL = {
  FEATURE_ACTION: '/v1/api/user/v1/feature/actions',
  HYPERVERGE_JWT_TOKEN: '/v1/api/doc/user/v1/generate_hv_jwt',
  PINCODE_DETAILS: '/v1/api/user/v1/register/config/pincode'
}

export const USER_DATA = {
  USER_ATTRIBUTES: '/v1/api/user/v3/attributes',
  ONLY_USER_DATA: '/v1/api/user/v2'
}

export const ACTIVATE_JOURNEY = '/v1/api/onboarding/dcp/v1/request/journeys/active'
